import { LanguagesService } from '@alpha-core/platform-ui';
import { ChangeDetectorRef, DestroyRef, Pipe, PipeTransform, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Pipe({
    name: 'translateConfig',
    pure: false,
    standalone: true,
})
export class TranslateConfigPipe implements PipeTransform {
    private languageService = inject(LanguagesService);
    private changeDetector = inject(ChangeDetectorRef);
    destroyRef = inject(DestroyRef);
    constructor() {
        this.languageService.selectedLanguage$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((language) => {
            this.changeDetector.markForCheck();
        });
    }

    transform(key: string, defaultValue: string = key): string {
        const translation = this.languageService.translateConfig(key);
        return translation || defaultValue;
    }
}
